export default __webpack_public_path__ + "static/media/192.d8672cf3.png";